import * as React from "react";
import { Box, Typography, colors } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowRightAltSharp } from "@mui/icons-material";
import CardBase from "../global/CardBase";

interface StatisticCardProps {
  title: string;
  value: string;
  url?: string;
  color?: string;
  gradientColor?: string;
}

const StatisticCard = ({
  title,
  value,
  url,
  color,
  gradientColor = colors.green[100],
}: StatisticCardProps) => {
  const navigate = useNavigate();

  const cardContent = (
    <Box>
      <Typography
        sx={{
          fontSize: { xs: "0.65rem", sm: 13, md: 14 },
          fontWeight: 500,
          mb: { xs: 0.5, sm: 1 }
        }}
        color={color ?? "text.secondary"}
      >
        {title}
      </Typography>
      <Typography
        variant="h4"
        component="div"
        sx={{
          fontWeight: 700,
          color: color ?? "text.primary",
          fontSize: { xs: "1.1rem", sm: "1.75rem", md: "2.125rem" },
          lineHeight: 1.2,
        }}
      >
        {value}
      </Typography>
    </Box>
  );

  return (
    <>
      <CardBase
        useGlassCard={true}
        gradientColor={gradientColor}
        actions={
          url && (
            <Box
              component="button"
              onClick={() => navigate(url)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 0,
                color: colors.green[600],
                fontSize: "0.875rem",
                fontWeight: 500,
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                  color: colors.green[700],
                  gap: 1,
                  "& .arrow-icon": {
                    transform: "translateX(4px)",
                  },
                },
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: "inherit",
                  fontSize: { xs: "0.7rem", sm: "inherit" },
                  fontWeight: "inherit",
                }}
              >
                More detail
              </Typography>
              <ArrowRightAltSharp
                className="arrow-icon"
                sx={{
                  fontSize: { xs: "0.85rem", sm: "1rem" },
                  transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                }}
              />
            </Box>
          )
        }
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          "& .MuiCardContent-root": {
            p: { xs: 1.5, sm: 2, md: 2.5 },
          },
        }}
      >
        {cardContent}
      </CardBase>
    </>
  );
};

export default StatisticCard;

